import { Injectable } from '@angular/core';
import { ComponentBase } from '../component-base';
import { StageService } from './stage.service';
import { BuildFloorService } from './build-floor.service';
import { SceneUtilsService } from './scene-utils.service';
import { SegmentsIntersectService } from './segments-intersect.service';
import { RailingGenerationService } from './railing/services/railing-generation.service';
import { Select3dService } from './select-3d.service';
import { EventLogService, Actions } from './eventLog';
import {AutoScaleSprite} from '../custom/AutoScaleSprite';
declare let THREE: any;

@Injectable()
export class CutUshapeService extends ComponentBase {

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private segmentIntersect: SegmentsIntersectService,
    private railingGeneration: RailingGenerationService,
    private buildFloorSrvc: BuildFloorService,
    private select3dService: Select3dService,
    private eventLog: EventLogService
  ) {
    super();
    this.disable();
    this.select3dService.selectedTierSubject.subscribe(value => {
      if (this.isEnabled()) {
        this.removeSprites();
        this.drawSprites();
      }
    });
  }
  // spriteMap = new THREE.TextureLoader().load('../../assets/images/welcome_page/cut_angle_active.png');
  // spriteMaterial = new THREE.SpriteMaterial({ map: this.spriteMap, color: 0xffffff });
  sprites = [];
  loader = new THREE.TextureLoader();
  private raycaster: any = new THREE.Raycaster(new THREE.Vector3(), new THREE.Vector3(0, -1, 0));

  drawSprites() {
    const floor = this.select3dService.getSelectedTier();
    let counter = 0;
    const points = floor.userData.points;
    const count = points.length;
    const cutPoints = [];
    const height = floor.getWorldPosition(new THREE.Vector3()).y;
    for (let i = 0; i < points.length; i++) {

      if (this.isEnablePoint(i, floor) && floor.userData.edges[i].length >= 120
        && !points[i].superstructureType) {
        cutPoints.push(i);
      }
    }

    for (let i = 0; i < cutPoints.length; i++) {

      const spriteMap = this.loader.load('../../assets/images/sprites/U_cut.png');

      const spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

      const sprite = new AutoScaleSprite(50, 50, spriteMaterial);
      sprite.userData.point = cutPoints[i];
      sprite.userData.floorId = floor.id;

      this.sprites.push(sprite);
      this.sprites[counter].position.set(
        (points[cutPoints[i]].x + points[(cutPoints[i] + 1) % points.length].x) / 2,
        height,
        (points[cutPoints[i]].y + points[(cutPoints[i] + 1) % points.length].y) / 2
      );
      this.stage.add(this.sprites[counter]);
      counter++;
    }
  }

  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites.splice(0, this.sprites.length);
  }

  disable() {
    this.removeSprites();
    super.disable();
  }

  mouseDown(e) {
    const p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    const intersection = this.raycaster.intersectObjects(this.sprites);
    if (intersection.length) {
      this.cut(intersection[0].object);
      this.removeSprites();
    }

  }

  isEnablePoint(pointIndex, fl) {
    const floor = fl;
    const points = floor.userData.points;
    let enable = true;
    const A = pointIndex > 0 ? (pointIndex - 1) % points.length : points.length - 1;
    const B = pointIndex;
    const C = (pointIndex + 1) % points.length;
    const point = new THREE.Vector2(points[B].x, points[B].y);
    // var vector1 = new THREE.Vector2(points[A].x - points[B].x, points[A].y - points[B].y);
    const vector1 = new THREE.Vector2((points[C].x - points[B].x) / 3, (points[C].y - points[B].y) / 3);
    const vector2 = new THREE.Vector2(-vector1.y, vector1.x);
    // vector2.rotateAround(new THREE.Vector2(0, 0), Math.PI / 2);

    const pointA = point.clone();
    const pointB = point.clone();
    const pointC = point.clone();
    const pointD = point.clone();

    pointA.add(vector1);
    pointB.add(vector1);
    pointB.add(vector2);
    pointC.add(vector1);
    pointC.add(vector1);
    pointC.add(vector2);
    pointD.add(vector1);
    pointD.add(vector1);

    for (let i = 0; i < points.length; i++) {
      if (i != B) {
        if (this.segmentIntersect.isIntersected(pointA, pointB, points[i], points[(i + 1) % points.length]) ||
          this.segmentIntersect.isIntersected(pointB, pointC, points[i], points[(i + 1) % points.length]) ||
          this.segmentIntersect.isIntersected(pointC, pointD, points[i], points[(i + 1) % points.length])) {
          enable = false;
        }
      }
    }

    return enable;
  }

  cut(intersection) {

    const pointIndex = intersection.userData.point;
    const floor = this.stage.getFloorById(intersection.userData.floorId);
    const points = floor.userData.points;
    const oldPoints = points.map(p => ({...p}));

    const A = pointIndex > 0 ? (pointIndex - 1) % points.length : points.length - 1;
    const B = pointIndex;
    const C = (pointIndex + 1) % points.length;
    const point = new THREE.Vector2(points[B].x, points[B].y);
    // var vector1 = new THREE.Vector2(points[A].x - points[B].x, points[A].y - points[B].y);
    const vector1 = new THREE.Vector2((points[C].x - points[B].x) / 3, (points[C].y - points[B].y) / 3);
    const vector2 = vector1.clone();
    vector2.rotateAround(new THREE.Vector2(0, 0), Math.PI / 2);

    const pointA = point.clone();
    const pointB = point.clone();
    const pointC = point.clone();
    const pointD = point.clone();

    pointA.add(vector1);
    pointB.add(vector1);
    pointB.add(vector2);
    pointC.add(vector1);
    pointC.add(vector1);
    pointC.add(vector2);
    pointD.add(vector1);
    pointD.add(vector1);

    points.splice(
      pointIndex + 1,
      0,
      {x: pointA.x, y: pointA.y},
      {x: pointB.x, y: pointB.y},
      {x: pointC.x, y: pointC.y},
      {x: pointD.x, y: pointD.y}
    );

    this.eventLog.dispatch(new Actions.EditFloorShapeAction(oldPoints, points, intersection.userData.floorId));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/cut-ushape.service.ts